import { render, staticRenderFns } from "./slideBar.vue?vue&type=template&id=4df247e8&scoped=true"
import script from "./slideBar.vue?vue&type=script&lang=js"
export * from "./slideBar.vue?vue&type=script&lang=js"
import style0 from "./slideBar.vue?vue&type=style&index=0&id=4df247e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df247e8",
  null
  
)

export default component.exports